import PlusCheckout from './PlusCheckout';

export default PlusCheckout;
